import { CSSProperties } from "react";
import { theme } from "antd";

export function VerticalBarchartIcon(props: {
  style?: CSSProperties;
  inactive?: boolean;
  size?: number;
}) {
  const { token } = theme.useToken();
  const size = props.size === undefined ? 16 : props.size;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity={props.inactive ? "0.5" : "0.9"}>
        <rect
          width="4.20833"
          height="14.0625"
          transform="matrix(0 1 -1 0 15.0625 0)"
          fill={props.inactive ? token.colorTextTertiary : token.colorText}
        />
        <rect
          width="4.20833"
          height="18.0625"
          transform="matrix(0 1 -1 0 19.0625 5.20833)"
          fill={props.inactive ? token.colorTextTertiary : token.colorText}
        />
        <rect
          width="4.20833"
          height="7"
          transform="matrix(0 1 -1 0 8 10.4167)"
          fill={props.inactive ? token.colorTextTertiary : token.colorText}
        />
      </g>
    </svg>
  );
}
